import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        tableContentWrapper: {
            padding: 0,
            borderRadius: 0,
            width: '100%',
            boxSizing: 'border-box',
            border: 'none',
            top: 0,
        },
        tableContent: {
            boxShadow: 'none !important',
            maxHeight: '50vh',
        },
        cardContent: {
            padding: theme.spacing(2),
            marginBottom: theme.spacing(2),
        },
        customBtn: {
            paddingRight: 10,
            minWidth: 225,
        },
    }
})

export default useStyles
